import React, { useState } from 'react';
import { ReactSVG } from 'react-svg';
import { CSSTransition } from 'react-transition-group';
import useKey from 'use-key-hook';
import FocusTrap from 'focus-trap-react';
import PropTypes from 'prop-types';

function MoreInfo({ content, isJumpstarter = false, ariaLabel = 'Open the info panel' }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
    document.body.classList.toggle('overflow-hidden');
  };

  // Close when Esc is pressed
  useKey(
    () => {
      setIsOpen(false);
      document.body.classList.remove('overflow-hidden');
    },
    {
      detectKeys: [27],
    },
  );

  return (
    <div className="more-info__holder">
      <button
        onClick={handleToggle}
        className="more-info"
        aria-label={ariaLabel}
      >
        {isJumpstarter ? <ReactSVG src="images/jumpstarter/icons/info.svg" className='more-info__icon'/> : <ReactSVG src="images/icons/moreinfo.svg" />}
      </button>
      {isOpen && (
        <FocusTrap>
          <CSSTransition
            in={isOpen}
            appear
            key={'moreinfo'}
            timeout={300}
            classNames="opacity"
          >
            <div
              role="dialog"
              aria-modal="true"
              className="more-info__block"
            >
              <CSSTransition
                in={isOpen}
                appear
                key={'moreinfo'}
                timeout={800}
                classNames="slide-right"
              >
                <div className="more-info__content">
                  <button
                    className="more-info__close"
                    onClick={handleToggle}
                    aria-label='Close'
                  >
                    <ReactSVG src="images/icons/close.svg" />
                  </button>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: content,
                    }}
                  ></div>
                </div>
              </CSSTransition>
            </div>
          </CSSTransition>
        </FocusTrap>
      )}
    </div>
  );
}

MoreInfo.propTypes = {
  content: PropTypes.string,
};

export default MoreInfo;
